import React from "react";
import { Input } from "components/bootstrap";
function MongoDBDataAdapterFieldSet({ config, handleFormEvent }) {
  return /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "checkbox",
      id: "cidr_lookup",
      name: "cidr_lookup",
      label: "CIDR lookup",
      checked: config.cidr_lookup,
      onChange: handleFormEvent,
      help: "Enable if the keys in the lookup table are in CIDR notation and lookups will be done with IPs",
      wrapperClassName: "col-md-offset-3 col-md-9"
    }
  ));
}
export default MongoDBDataAdapterFieldSet;
